<mat-card class="review-assets content">
  <div class="review-assets__wrapper">
    <div class="review-assets__title">
      <div class="content-header title">
        {{ title }}
        <button
          matSuffix
          mat-icon-button
          matTooltip="Page Link"
          matTooltipPosition="above"
          (click)="
            this.clipboardService.copyUrlAndTextToClipboard(
              this.urlService.getFullUrl(),
              this.pageLink
            )
          "
          >
          <mat-icon>link</mat-icon>
        </button>
        @if (formulaScoped) {
          <mat-button-toggle-group
            class="kind-toggle"
            data-testid="kind-toggle"
            [value]="activeKind"
            (change)="onKindChange($event.value)"
            aria-label="Output asset kind">
            <mat-button-toggle value="range">
              <mat-icon>format_list_numbered</mat-icon>
              Range
            </mat-button-toggle>
            <mat-button-toggle value="ev">
              <mat-icon>tune</mat-icon>
              EV
            </mat-button-toggle>
          </mat-button-toggle-group>
        }
      </div>

      <div>
        <h4>{{ label }}</h4>
        <h4 class="router-link" (click)="onBack()">Back to Product Details</h4>
      </div>
    </div>

    <div class="review-assets__content">
      <div
        class="review-assets__preview"
        [style]="{
          width: assetType == 'output-asset' && !authService.hasPermission(Permission.OutputAssetsFull) ? '100%' : ''
        }"
        >
        <div class="review-assets__img">
          <div class="review-assets__version">
            <div class="review-assets__old-version">
              <mat-tab-group
                [selectedIndex]="activeTab"
                (selectedIndexChange)="onChangeVersion($event)"
                >
                @for (tab of assetData; track tab.id; let i = $index) {
                  <mat-tab>
                    <ng-template mat-tab-label>
                      @if (i === 0 && tab.pinnedVersion) {
                        <span
                          >Pinned (v{{ tab.versionNumber }})</span
                          >
                        }
                        @if (i === 0 && !tab.pinnedVersion) {
                          <span
                            >Latest (v{{ tab.versionNumber }})</span
                            >
                          }
                          @if (i !== 0) {
                            <span>v{{ tab.versionNumber }}</span>
                          }
                        </ng-template>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </div>
              <div class="review-assets__img-overlay">
                @if (loading) {
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
                @if (!loading) {
                  <div class="review-assets__img-content">
                    @if (isCompare) {
                      <app-compare-image
                        [src1]="getLinkImage(currentAsset)"
                        [src2]="getLinkImage(compareAsset)"
                        (stopCompare)="isCompare = false"
                        (downloadRequested)="downLoadImage(assetData[activeTab].rawUri)"
                      ></app-compare-image>
                    }
                    @if (!isCompare) {
                      <div class="review-assets__img-compare">
                        @if (assetData[0] != undefined) {
                          <div
                            #assetContainer
                            class="review-assets__compare-item"
                            >
                            @if (activeTab !== 0 && !!assetData[activeTab]) {
                              <div
                                class="review-assets__compare-item-label left"
                                >
                                v{{ assetData[0].versionNumber }}
                              </div>
                            }
                            <div class="image-container" style="position: relative; display: inline-block">
                              @if (
                                assetData[0].type == 'Still' || assetData[0].reviewUri?.includes('gif')) {
                                <img
                                  #asset
                                  [ngClass]="{ blur: drawing }"
                      [style]="{
                        'background-image': background(),
                        'margin-top': checkMargin(false)
                      }"
                                  [src]="getLinkImage(currentAsset) | secure | async"
                                  [alt]="getLinkImage(currentAsset) | secure | async"
                                  (mousedown)="drawing ? startDrawing($event) : ''"
                                  (mousemove)="drawing ? keepDrawing($event) : ''"
                                  (mouseup)="drawing ? stopDrawing() : ''"
                                  />
                              } @else {
                                <video
                                  [style]="{ 'margin-top': checkMargin(false) }"
                                  #asset
                                  mat-card-image
                                  [src]="getLinkImage(currentAsset) | secure | async"
                                  controls
                                  autoplay="1"
                                ></video>
                                <!-- <div
                                [hidden]="hideVideoSubjectBoundingBox"
                                class="overlay-box"
                        [style]="{
                          top: [this.subjectBoundingBoxPercentage.top],
                          left: [this.subjectBoundingBoxPercentage.left],
                          width: [this.subjectBoundingBoxPercentage.width],
                          height: [this.subjectBoundingBoxPercentage.height]
                        }"
                              ></div> -->
                              <div class="asset-actions">
                                <!-- <button
                                mat-icon-button
                                *ngIf="activeTab == 0"
                        (click)="
                          hideVideoSubjectBoundingBox =
                            !hideVideoSubjectBoundingBox
                        "
                                matTooltip="Subject bounding box"
                                matTooltipPosition="above"
                                >
                                <mat-icon> check_box_outline_blank </mat-icon>
                              </button> -->
                              @if ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull))) {
                                <button
                                  mat-icon-button
                                  [matTooltip]="toggleExtraActions ? 'Hide' : 'Show More'"
                                  matTooltipPosition="above"
                                  (click)="toggleExtraActions = !toggleExtraActions"
                                  >
                                  @if (!toggleExtraActions) {
                                    <mat-icon> keyboard_arrow_left </mat-icon>
                                  }
                                  @if (toggleExtraActions) {
                                    <mat-icon> keyboard_arrow_right </mat-icon>
                                  }
                                </button>
                              }
                              @if (
                                toggleExtraActions &&
                                this.activeTab == 0 &&
                                assetData[this.activeTab].pinnedVersion &&
                                ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))
                                ) {
                                <button
                                  mat-icon-button
                                  matTooltip="Un-Pin Version"
                                  matTooltipPosition="above"
                                  (click)="pinAssetVersion(assetData[this.activeTab].id, false)"
                                  >
                                  <mat-icon style="rotate: 180deg"> push_pin </mat-icon>
                                </button>
                              }
                              @if (toggleExtraActions && activeTab == 0 && ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                                <button
                                  mat-icon-button
                                  (click)="deleteAssetDialog(assetData[this.activeTab].id)"
                                  matTooltip="Delete"
                                  matTooltipPosition="above"
                                  >
                                  <mat-icon> delete </mat-icon>
                                </button>
                              }
                              @if (toggleExtraActions && assetType != 'shoot-asset' && (((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                                <button
                                  mat-icon-button
                                  (click)="openParentAsset(assetType == 'post-asset')"
                        [matTooltip]="
                          assetType == 'post-asset' || assetType == 'auto-post-asset'
                            ? 'View Shoot Asset'
                            : 'View Post Asset'
                        "
                                  matTooltipPosition="above"
                                  >
                                  <mat-icon> open_in_new </mat-icon>
                                </button>
                              }
                              @if (activeTab == 0) {
                                <button
                                  mat-icon-button
                                  (click)="downLoadImage(assetData[activeTab].rawUri)"
                                  [disabled]="isDownloadFileLoading"
                                  >
                                  <mat-icon> file_download </mat-icon>
                                </button>
                              }
                            </div>
                          }
                        </div>
                        @if (!invalidLabelRegion && activeTab == 0) {
                          <div
                            class="box-container"
                    [style]="{
                      'margin-top': checkMargin(false),
                      'margin-bottom': checkMargin(false),
                      'margin-left': checkMargin(true),
                      'margin-right': checkMargin(true)
                    }"
                            >
                            <div
                              class="shape"
                      [style]="{
                        top: [this.imageLabelBoundingBoxPercentage.top],
                        left: [this.imageLabelBoundingBoxPercentage.left],
                        width: [this.imageLabelBoundingBoxPercentage.width],
                        height: [this.imageLabelBoundingBoxPercentage.height]
                      }"
                            ></div>
                          </div>
                        }
                        @if (box || finalBox) {
                          <div
                            class="box-container"
                    [style]="{
                      'margin-top': checkMargin(false),
                      'margin-bottom': checkMargin(false),
                      'margin-left': checkMargin(true),
                      'margin-right': checkMargin(true)
                    }"
                            >
                            @if (box) {
                              <div
                                class="shape"
                      [style]="{
                        left: box.left * 100 + '%',
                        top: box.top * 100 + '%',
                        width: box.width * 100 + '%',
                        height: box.height * 100 + '%'
                      }"
                              ></div>
                            }
                            @if (drawn && finalBox && assetData[0].id == activeVersionId) {
                              <div
                                class="shape"
                      [style]="{
                        left: finalBox.left * 100 + '%',
                        top: finalBox.top * 100 + '%',
                        width: finalBox.width * 100 + '%',
                        height: finalBox.height * 100 + '%'
                      }"
                              ></div>
                            }
                          </div>
                        }
                        @if (activeTab == 0 && assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)) {
                          <button
                            style="position: absolute; left: 1%; top: 1%"
                            mat-raised-button
                    [color]="
                      assetData[0].internalReviewState == 'Accepted'
                        ? 'buttonError'
                        : 'buttonSuccess'
                    "
                    (click)="
                      reviewOutputAsset(
                        assetData[0].id,
                        assetData[0].internalReviewState == 'Accepted' ? 'Rejected' : 'Accepted'
                      )
                    "
                            >
                            {{ assetData[0].internalReviewState == 'Accepted' ? 'Reject' : 'Approve' }}
                          </button>
                        }
                        @if (assetData[0].type == 'Still') {
                          <div class="asset-actions">
                            @if (this.activeTab == 0 && ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                              <button
                                mat-icon-button
                                [matTooltip]="toggleExtraActions ? 'Hide' : 'Show More'"
                                matTooltipPosition="above"
                                (click)="toggleExtraActions = !toggleExtraActions"
                                >
                                @if (!toggleExtraActions) {
                                  <mat-icon> keyboard_arrow_left </mat-icon>
                                }
                                @if (toggleExtraActions) {
                                  <mat-icon> keyboard_arrow_right </mat-icon>
                                }
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              this.activeTab == 0 &&
                              assetData[this.activeTab].pinnedVersion &&
                              ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))
                              ) {
                              <button
                                mat-icon-button
                                matTooltip="Un-Pin Version"
                                matTooltipPosition="above"
                                (click)="pinAssetVersion(assetData[this.activeTab].id, false)"
                                >
                                <mat-icon style="rotate: 180deg"> push_pin </mat-icon>
                              </button>
                            }
                            @if (toggleExtraActions && activeTab == 0 && ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                              <button
                                mat-icon-button
                                (click)="deleteAssetDialog(assetData[this.activeTab].id)"
                                matTooltip="Delete"
                                matTooltipPosition="above"
                                >
                                <mat-icon> delete </mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions && activeTab == 0 && assetType == 'post-asset' && authService.hasPermission(Permission.OutputAssetsFull)
                              ) {
                              <button
                                mat-icon-button
                                matTooltip="Generate Outputs"
                                (click)="generateOutputAssets()"
                                >
                                <mat-icon>sync</mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              activeTab == 0 &&
                              assetType == 'auto-post-asset' &&
                              authService.hasPermission(Permission.PostAssetsFull)
                              ) {
                              <button
                                mat-icon-button
                                matTooltip="Re-generate"
                                (click)="generateAutoPostAsset(assetData[0].shootAssetId)"
                                >
                                <mat-icon>sync</mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              activeTab == 0 &&
                              assetType != 'shoot-asset' &&
                              (((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))
                              ) {
                              <button
                                mat-icon-button
                      (click)="
                        openParentAsset(assetType == 'post-asset' || assetType == 'auto-post-asset')
                      "
                      [matTooltip]="
                        assetType == 'post-asset' || assetType == 'auto-post-asset'
                          ? 'View Shoot Asset'
                          : 'View Post Asset'
                      "
                                matTooltipPosition="above"
                                >
                                <mat-icon> open_in_new </mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              activeTab == 0 &&
                              assetData[0].type == 'Still' &&
                              assetType == 'shoot-asset' &&
                              authService.hasPermission(Permission.ShootAssetsFull)
                              ) {
                              <button
                                mat-icon-button
                                (click)="generateAutoPostAsset(assetData[0].id)"
                                matTooltip="Generate Post Asset"
                                matTooltipPosition="above"
                                >
                                <mat-icon> auto_awesome </mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              activeTab == 0 &&
                              assetData[0].type == 'Still' &&
                              (assetType == 'post-asset' || assetType == 'auto-post-asset') &&
                              authService.hasPermission(Permission.PostAssetsFull)
                              ) {
                              <button
                                mat-icon-button
                                (click)="compareChange(true, assetData[0].shootAssetReviewUri)"
                                matTooltip="Compare Shoot Asset"
                                matTooltipPosition="above"
                                >
                                <mat-icon> compare </mat-icon>
                              </button>
                            }
                            @if (
                              toggleExtraActions &&
                              activeTab == 0 &&
                              assetType != 'output-asset' &&
                              ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))))
                              ) {
                              <button
                                mat-icon-button
                                matTooltip="Highlight"
                                matTooltipPosition="above"
                                (click)="toggleDrawing()"
                                >
                                @if (!drawing) {
                                  <mat-icon> rate_review </mat-icon>
                                }
                                @if (drawing) {
                                  <mat-icon> cancel </mat-icon>
                                }
                              </button>
                            }
                            @if (toggleExtraActions && activeTab == 0 && assetType != 'shoot-asset') {
                              <button
                                matTooltip="Toggle Transparency"
                                matTooltipPosition="above"
                                mat-icon-button
                                (click)="transparentBackground = !transparentBackground"
                                >
                                @if (transparentBackground) {
                                  <mat-icon> invert_colors </mat-icon>
                                }
                                @if (!transparentBackground) {
                                  <mat-icon> invert_colors_off </mat-icon>
                                }
                              </button>
                            }
                            @if (activeTab == 0) {
                              <button
                                matTooltip="Fullscreen"
                                matTooltipPosition="above"
                                mat-icon-button
                                (click)="fullscreen = true"
                                >
                                <mat-icon> fullscreen </mat-icon>
                              </button>
                            }
                            @if (activeTab == 0 && assetType != 'auto-post-asset') {
                              <button
                                mat-icon-button
                                (click)="downLoadImage(assetData[activeTab].rawUri)"
                                [disabled]="isDownloadFileLoading"
                                >
                                <mat-icon> file_download </mat-icon>
                              </button>
                            }
                            @if (activeTab == 0 && assetType == 'auto-post-asset') {
                              <button
                                mat-icon-button
                                [matMenuTriggerFor]="menu"
                                #menuTrigger="matMenuTrigger"
                                >
                                <mat-icon>file_download</mat-icon>
                              </button>
                            }
                            <!-- Menu -->
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item (click)="downLoadImage(assetData[activeTab].rawUri)">
                                Raw
                              </button>
                              @if (
                                assetData[activeTab].editableRawUri != null &&
                                assetData[activeTab].editableRawUri.length > 0
                                ) {
                                <button
                                  mat-menu-item
                                  (click)="downLoadImage(assetData[activeTab].editableRawUri)"
                                  >
                                  PSD
                                </button>
                              }
                              @if (
                                assetData[activeTab].maskUri != null &&
                                assetData[activeTab].maskUri.length > 0
                                ) {
                                <button
                                  mat-menu-item
                                  (click)="downLoadImage(assetData[activeTab].maskUri)"
                                  >
                                  Mask
                                </button>
                              }
                              @if (
                                assetData[activeTab].archiveUri != null &&
                                assetData[activeTab].archiveUri.length > 0
                                ) {
                                <button
                                  mat-menu-item
                                  (click)="downLoadImage(assetData[activeTab].archiveUri)"
                                  >
                                  Archive
                                </button>
                              }
                            </mat-menu>
                          </div>
                        }
                      </div>
                    }
                    @if (activeTab !== 0 && !!assetData[activeTab]) {
                      <div
                        class="review-assets__compare-item"
                        >
                        <div class="review-assets__compare-item-label left">
                          v{{ assetData[activeTab].versionNumber }}
                        </div>
                        @if (assetData[activeTab].type !== 'Still') {
                          <video
                            mat-card-image
                            [src]="getLinkImage(compareAsset) | secure | async"
                            controls
                            autoplay="1"
                          ></video>
                        } @else {
                          <img
                            [src]="getLinkImage(compareAsset) | secure | async"
                            [alt]="getLinkImage(compareAsset) | secure | async"
                            />
                          <div
                            class="box-container"
                      [style]="{
                        'margin-top': checkMargin(false),
                        'margin-bottom': checkMargin(false),
                        'margin-left': checkMargin(true),
                        'margin-right': checkMargin(true)
                      }"
                            >
                            @if (drawn && finalBox && assetData[activeTab].id == activeVersionId) {
                              <div
                                class="shape"
                        [style]="{
                          left: finalBox.left * 100 + '%',
                          top: finalBox.top * 100 + '%',
                          width: finalBox.width * 100 + '%',
                          height: finalBox.height * 100 + '%'
                        }"
                              ></div>
                            }
                          </div>
                        }
                        <div class="asset-actions">
                          @if ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || (assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull)) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull))) {
                            <button
                              mat-icon-button
                              [matTooltip]="toggleExtraActions ? 'Hide' : 'Show More'"
                              matTooltipPosition="above"
                              (click)="toggleExtraActions = !toggleExtraActions"
                              >
                              @if (!toggleExtraActions) {
                                <mat-icon> keyboard_arrow_left </mat-icon>
                              }
                              @if (toggleExtraActions) {
                                <mat-icon> keyboard_arrow_right </mat-icon>
                              }
                            </button>
                          }
                          @if (toggleExtraActions && ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || (assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull)) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                            <button
                              mat-icon-button
                              matTooltip="Pin Version"
                              matTooltipPosition="above"
                              (click)="pinAssetVersion(assetData[this.activeTab].id, true)"
                              >
                              @if (toggleExtraActions && !assetData[this.activeTab].pinnedVersion) {
                                <mat-icon
                                  >
                                  push_pin
                                </mat-icon>
                              }
                            </button>
                          }
                          @if (toggleExtraActions && ((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsFull)) || (assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull)) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                            <button
                              mat-icon-button
                              (click)="deleteAssetDialog(assetData[this.activeTab].id)"
                              matTooltip="Delete"
                              matTooltipPosition="above"
                              >
                              <mat-icon> delete </mat-icon>
                            </button>
                          }
                          @if (toggleExtraActions && assetType != 'shoot-asset' && ((assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsFull)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull)) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)))) {
                            <button
                              mat-icon-button
                              (click)="openParentAsset(assetType == 'post-asset')"
                      [matTooltip]="
                        assetType == 'post-asset' || assetType == 'auto-post-asset'
                          ? 'View Shoot Asset'
                          : 'View Post Asset'
                      "
                              matTooltipPosition="above"
                              >
                              <mat-icon> open_in_new </mat-icon>
                            </button>
                          }
                          @if (activeTab != 0 && assetData[0].type == 'Still') {
                            <button
                              mat-icon-button
                              (click)="compareChange(true, assetData[this.activeTab].reviewUri)"
                              matTooltip="Compare Versions"
                              >
                              <mat-icon> compare </mat-icon>
                            </button>
                          }
                          <button
                            mat-icon-button
                            (click)="downLoadImage(assetData[activeTab].rawUri)"
                            [disabled]="isDownloadFileLoading"
                            >
                            <mat-icon> file_download </mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="review-assets__navigate">
          @if (!!productId) {
            <app-assets-navigate
              #assetNavigate
              [productId]="productId"
              [assetType]="assetType"
              [fullscreen]="fullscreen"
              [activeKind]="activeKind"
              (navigated)="initialData()"
              (loaded)="onLoadedNavigate($event)"
            ></app-assets-navigate>
          }
        </div>
      </div>
      @if (((assetType == 'shoot-asset' && authService.hasPermission(Permission.ShootAssetsComment)) || (assetType == 'post-asset' && authService.hasPermission(Permission.PostAssetsInternalComment)) || (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull)) || (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull))) && initialized) {
        <div class="review-assets__feedback">
          <div
            class="review-assets__chatbox"
            [ngClass]="{ 'hide-action': !authService.hasPermission(Permission.ShootAssetsRead) && !assetData[activeTab]?.internalReviewState }"
            >
            @if (assetData.length > 0 && !!productTouchAssetId) {
              <app-chat-box
                [assetType]="assetType"
                [organizationId]="activeAsset.organizationId"
                [productTouchAssetId]="productTouchAssetId"
                [masterSuiteTouchAssetId]="masterSuiteTouchAssetId"
                [currentAsset]="assetData[0]"
                [assetDetail]="assetData[activeTab]"
            [onlyProperties]="
              (assetType == 'output-asset' && authService.hasPermission(Permission.OutputAssetsFull)) ||
              (assetType == 'auto-post-asset' && authService.hasPermission(Permission.AutoPostAssetsFull))
            "
                [commentBoundingBox]="drawing ? finalBox : null"
                [contentExtracting]="assetData[activeTab].contentExtracting"
                (versionSelected)="onOpenVersion($event)"
                (commentHover)="commentHover($event)"
                (clearBoundingBox)="drawing ? toggleDrawing() : ''"
                (propertiesSelected)="propertiesView = $event"
                (labelViewEmitter)="labelView = $event"
                (boundingBoxProportionEmitter)="this.saveBoundingBoxPercentage($event)"
                (contentExtractingEmitter)="assetData[activeTab].contentExtracting = $event"
              ></app-chat-box>
            }
          </div>
          @if (assetData[activeTab] && (authService.hasPermission(Permission.ShootAssetsComment) || authService.hasPermission(Permission.PostAssetsInternalComment)) && !propertiesView && !labelView) {
            <div
              class="review-assets__actions"
              >
              <app-review-actions
                [disabled]="assetData[0]?.id !== assetData[activeTab]?.id"
                [assetDetail]="assetData[activeTab]"
                (onReload)="onReload()"
              ></app-review-actions>
            </div>
          }
        </div>
      }
    </div>
  </div>
</mat-card>

@if (fullscreen) {
  <app-review-fullscreen
    [currentAsset]="getLinkImage(currentAsset)"
    (exit)="fullscreen = false"
  ></app-review-fullscreen>
}
